import { Stack, Typography } from '@mui/material';
import { FormSelect } from 'components/form';

import { DEALER_TIER_OPTIONS, DealerTier } from '../../../constants';

interface Props {
  disabled?: boolean;
  value: DealerTier | null | undefined;
  onChange: (value: DealerTier | null) => void;
}

export const DealerTierSection = ({ value, onChange, disabled }: Props) => {
  const handleChange = (value: DealerTier) => {
    onChange(value);
  };

  return (
    <Stack gap="0.5rem">
      <Typography variant="h6" component="span">
        Tier:
      </Typography>

      <FormSelect
        value={value}
        disabled={disabled}
        label="Dealer Tier"
        onValueChange={handleChange}
        options={DEALER_TIER_OPTIONS}
      />
    </Stack>
  );
};
